import { TextField } from '@global-engineering-shared/gweb-material-ui';
import React, { useState } from 'react';

import useStyles from 'components/FilterAutocomplete/components/FrameIdsInput/FrameIdsInput.styles';
import { setErrorMessagesForIds } from 'components/FilterAutocomplete/utils/setErrorMessageForIds';
import { Filters } from 'context/FilterProvider/types/Filters';

type frameIdsInputProps = {
  options: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<Filters>>;
  filterKey: string;
};

const FrameIdsInput = ({ options, setSelectedFilters, filterKey }: frameIdsInputProps) => {
  const classes = useStyles();

  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const onChangeAndPaste = (event: React.ChangeEvent<HTMLInputElement>) => {
    const typedOrPastedValue = event.target.value;

    const newValues = setErrorMessagesForIds(typedOrPastedValue, setErrorMessage, options);

    setSelectedFilters((prevFilters) => ({
      ...prevFilters,
      [filterKey as keyof Filters]: newValues,
    }));
  };

  return (
    <TextField
      className={classes.frameIdsTextBox}
      data-testid="frameIdsInput"
      label="Frame IDs"
      onChange={onChangeAndPaste}
      error={!!errorMessage}
      helperText={
        errorMessage && (
          <span
            id="errorMessage"
            data-testid="errorMessage"
            style={{ whiteSpace: 'pre-wrap', fontWeight: 'bold', fontSize: '14px' }}
          >
            {errorMessage}
          </span>
        )
      }
      placeholder="123456789, 234567891, 3455678912"
    />
  );
};

export default FrameIdsInput;
